import { TableHeader } from '@/components/data-table/DataTable';
import { RestrictType } from '@/interfaces/RestrictType';
import { Model } from '@/models/Model';

// #region MODEL

export type MediaIncludeType = '';

export enum MediaTypeEnum {
  PURCHASE_ORDER = 'PurchaseOrder',
}

export interface MediaFilterInterface {
  id?: string;
  type?: MediaTypeEnum;
};

export type MediaFilterKeyType = keyof MediaFilterInterface;

export class Media extends Model{
  protected $name: string = 'Media';

  protected $endpoint: string = '/media';

  protected $fillable: MediaKeyType[] = ['id', 'image', 'type'];

  protected $includes: MediaIncludeType[] = [];

  protected filters: MediaFilterInterface = {};

  public id?: string;

  public image?: File;

  public name?: string;

  public type?: MediaTypeEnum;

  public url?: string;

  public include(includes: MediaIncludeType | MediaIncludeType[]): this {
    return super.include.call(this, includes);
  }

  public removeFilter(key: MediaFilterKeyType): this {
    return super.removeFilter.call(this, key);
  }

  public filter(filters: MediaFilterKeyType | MediaFilterInterface, value?: any) {
    return super.filter.call(this, filters, value);
  }
}

export type MediaKeyType = Exclude<keyof Media, keyof Model>;

// #endregion

// #region MODEL: TABLE HEADER

export class MediaTableHeaderClass implements RestrictType<MediaKeyType, TableHeader, MediaTableHeaderClass> {
  get id(): TableHeader {
    return {
      value: 'id',
      text: 'ID',
    }
  }

  get image(): TableHeader {
    return {
      value: 'file',
      text: 'File',
    }
  }

  get name(): TableHeader {
    return {
      value: 'name',
      text: 'Name',
      transform: (name: string, media: Media) => {
        if (!media || !media.url || !media.name) { return; }

        return `<a href="${media.url}" target="_blank" download="${name}">${name}</a>`;
      },
    }
  }

  get type(): TableHeader {
    return {
      value: 'type',
      text: 'Type',
    }
  }

  get url(): TableHeader {
    return {
      value: 'url',
      text: 'Url',
    }
  }
}

export const MediaTableHeader = new MediaTableHeaderClass();

// #endregion
